export default __webpack_public_path__ + "static/media/January2009.046dc13f.png";